/**
 * dateFormat.js — single source of truth for customer-facing date
 * formatting across the QorTrace site.
 *
 * Convention (per user directive, iter167):
 *   All customer-facing dates render as `Month Day, Year`
 *   (e.g. "March 21, 2026") — never numeric `3/21/2026` or
 *   day-first `21 March 2026`.
 *
 * Admin/internal date displays (e.g. /admin/* pages, audit log
 * timestamps) are intentionally NOT routed through this helper —
 * they remain locale-default `toLocaleDateString()` so terse table
 * cells stay terse.  If you're rendering a date that a paying
 * customer or anonymous visitor will see, call `formatLongDate` here.
 */

const MONTHS = [
  "January", "February", "March",     "April",   "May",      "June",
  "July",    "August",   "September", "October", "November", "December",
];

/**
 * Format any date-ish input as "Month Day, Year".
 *
 * @param {string | Date | number | null | undefined} input
 *   ISO string, Date instance, epoch ms, or empty.
 * @returns {string}
 *   "March 21, 2026" — empty string on falsy / invalid input
 *   (so callers can drop the result into JSX without guarding).
 */
export function formatLongDate(input) {
  if (input === null || input === undefined || input === "") return "";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}
